class DynamicTabs extends HTMLElement {
	constructor() {
		super();

		this.selectors = {
			heading: '.dynamic-tabs .tab-heading',
			contentTab: '.dynamic-tabs .tab-content',
			tabHidden: '[data-hide-tab]',
		};

		this.classes = {
			heading: 'tab-heading',
			headingActive: 'tab-heading--active',
			headingHidden: 'tab-heading--hidden',
			tabVisible: 'tab-content--active',
		};

		this.activeIndex = 0;
		this.headings = document.querySelectorAll(this.selectors.heading);
		this.infos = document.querySelectorAll(this.selectors.contentTab);
	}

	connectedCallback() {
		this.headings.forEach((head) => head.addEventListener('click', (e) => this.changeTabs(e)));
		this.checkForEmptyTabs();
	}

	checkForEmptyTabs() {
		this.infos.forEach((tab, index) => {
			if (tab.querySelector(this.selectors.tabHidden)) {
				this.headings[index].remove();
				tab.remove();
			} else {
				this.headings[index].classList.remove(this.classes.headingHidden);
			}
		});
	}

	changeTabs(e) {
		if (e.target.classList.contains(this.classes.headingActive)) return;

		this.activeIndex = +e.target.dataset.tab;

		this.toggleClasses(this.infos, this.classes.tabVisible);
		this.toggleClasses(this.headings, this.classes.headingActive);
	}

	toggleClasses(listOfElements, classToToggle) {
		listOfElements.forEach((element, index) => {
			if (index !== this.activeIndex) {
				element.classList.remove(classToToggle);
			} else {
				element.classList.add(classToToggle);
			}
		});
	}
}

customElements.define('dynamic-tabs', DynamicTabs);
